export const BUTTONRADIUS = { none: 0, sm: 1, md: 3, xl: 25 };
export const BUTTONWIDTH = {
  none: "0px",
  sm: "min(100px, 100%)",
  md: "min(200px, 100%)",
  "full-width": "100%",
  "fit-content": "fit-content",
};
